import {takeEvery} from 'redux-saga/effects'
import {
  CONFIRM_DOC_UPLOAD,
  DELETE_DOCUMENT,
  GET_DOCUMENT,
  GET_DOCUMENTS,
  GET_DOC_SIGNED_URL,
} from 'setup/redux/Actions/Document/ActionTypes/ApiActionTypes'

import fetchData from '../SagaHelper'

function* dataSaga() {
  yield takeEvery(GET_DOCUMENTS, fetchData)
  yield takeEvery(GET_DOCUMENT, fetchData)
  yield takeEvery(DELETE_DOCUMENT, fetchData)
  yield takeEvery(GET_DOC_SIGNED_URL, fetchData)
  yield takeEvery(CONFIRM_DOC_UPLOAD, fetchData)
}

export default dataSaga
